import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
	background: white;
	border-radius: 0.75rem;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);;
	padding: 0.5rem;
    width: max-content;
`;

const TabList = styled.div`
	display: flex;
	gap: 1rem;
	position: relative;
`;

const TabButton = styled.div`
	padding: 0.75rem 1.25rem;
	font-size: 0.875rem;
	font-weight: 500;
	border-radius: 0.5rem;
	transition: all 0.2s ease-in-out;
	position: relative;
	color: ${(props) => (props.$isActive ? "#2563eb" : "#4b5563")};
	background: ${(props) => (props.$isActive ? "#EFF6FF" : "transparent")};

	&:hover {
		color: ${(props) => (props.$isActive ? "#2563eb" : "#1f2937")};
		background: ${(props) => (props.$isActive ? "#EFF6FF" : "#F3F4F6")};
	}
`;

const EmptyState = styled.div`
	padding: 1rem;
	text-align: center;
	color: #6b7280;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
`;

const EmptyStateIcon = styled.div`
	color: #9ca3af;
	display: inline-flex;
`;

const EmptyStateText = styled.span`
	font-size: 0.875rem;
	font-weight: 500;
`;

const TabHeader = ({ tabs = [], activeTabId, onChange }) => {
	if (!tabs || tabs.length === 0) {
		return (
			<Container>
				<EmptyState>
					<EmptyStateText>No tabs available</EmptyStateText>
				</EmptyState>
			</Container>
		);
	}

	return (
		<Container>
			<TabList>
				{tabs.map((tab) => (
					<TabButton key={tab.id} $isActive={activeTabId === tab.id} onClick={() => onChange(tab.id)}>
						{tab.label}
					</TabButton>
				))}
			</TabList>
		</Container>
	);
};

export default TabHeader;
